import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/campaignType";
export default class CampaignTypeService {
    static restrictedList(options = {}) {
        // @ts-expect-error TODO fix this -- why are we mapping to something other than a CampaignAction but saying that this returns a campaign action?
        return FetchService.getSingleResponse(BASE_URL + "/restrictedList", {
            query: options.query,
        }).then((data) => {
            var _a;
            return (_a = data
                .map((campaignType) => ({
                id: campaignType.id,
                title: campaignType.name,
                description: campaignType.description,
            }))) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
                return a.title > b.title ? 1 : -1;
            });
        });
    }
    static search(search = {}, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ids: search.ids,
            names: search.names,
            query: search.query,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
}
